export const balanceBonus = {
  balanceBonus_title: "Bonus",
  balanceBonus_statusActive: "Active",
  balanceBonus_statusUnlocked: "Unlocked",
  balanceBonus_explain: "Playable on slots and lottery only. Not withdrawable.",
  balanceBonus_progressLabel: "Wagering progress",
  balanceBonus_wageringRemaining: "Wager {{amount}} more to unlock your winnings",
  balanceBonus_wageringMet: "Winnings unlocked!",
  balanceBonus_expires: "Expires on {{date}}",
};

export default balanceBonus;
